module.exports = __webpack_public_path__ + "img/photo-sharing-demo.a8aac3e2.gif";